import {toPoint} from '@/utils/polyline'

/**
 * A Mapbox STATIC image of a trip's route — for list cards, where a live map per row
 * would mean a WebGL context per ride. One <img>, cached by the browser like any other.
 *
 * The route is drawn from the trip's own encoded polyline (precision 5, which is what
 * Mapbox's `path` overlay reads). A very long polyline can push the URL past Mapbox's
 * 8KB limit, so past that it falls back to two pins, pickup and drop-off.
 *
 * Returns null when there is nothing to draw or no token — the caller shows its
 * placeholder instead.
 */
const MAX_URL = 7800

export function staticRouteMapUrl(trip, {token, styleUrl, width = 600, height = 300}) {
    if (!token || !styleUrl) return null
    const style = String(styleUrl).replace(/^mapbox:\/\/styles\//, '')
    const base = `https://api.mapbox.com/styles/v1/${style}/static`
    const tail = `/auto/${width}x${height}@2x?padding=40&attribution=false&logo=false&access_token=${token}`

    const polyline = trip?.route?.polyline
    if (polyline) {
        const url = `${base}/path-5+5ee6bf-1(${encodeURIComponent(polyline)})${tail}`
        if (url.length <= MAX_URL) return url
    }

    const a = toPoint(typeof trip?.origin === 'object' ? trip.origin : null)
    const b = toPoint(typeof trip?.destination === 'object' ? trip.destination : null)
    const pins = [a && `pin-s+201e20(${a.lng},${a.lat})`, b && `pin-s+201e20(${b.lng},${b.lat})`].filter(Boolean)
    return pins.length ? `${base}/${pins.join(',')}${tail}` : null
}
